import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [], // Store the entire API response here
};

const ProfileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    ProfileSuccess: (state, action) => {
      state.data = action.payload; // Store the entire API response
    },
  },
});

export const { ProfileSuccess } = ProfileSlice.actions;
export default ProfileSlice.reducer;